/*
 * @Descripttion:
 * @version: 0.0.1
 * @Author: gavin chan
 * @Date: 2020-06-02 11:55:24
 * @LastEditors: gavin chan
 * @LastEditTime: 2020-08-26 14:34:23
 * @Notes:
 */

export const buildTreeData = (data: any, keyname: string): any => {
  let nodes = [];
  // let node = [];
  for (const item of data) {
    if (item.children && item.children.length > 0) {
      nodes.push({
        // key&value 在selectTree中被用做key,唯一值，也用于搜索
        [keyname]: item.folderName,
        value: item.folderName,
        id: item.id,
        pid: item.pid,
        title: item.folderName,
        children: buildTreeData(item.children, keyname),
      });
    } else {
      nodes.push({
        [keyname]: item.folderName,
        value: item.folderName,
        id: item.id,
        pid: item.pid,
        title: item.folderName,
      });
    }
  }
  return nodes;
};

// export const RangerPickerFormatter = (array, values) => {
//   if(Array.isArray(array)) {
//     Object.assign({ array[0] })
//   }

// }
